// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__36pev","label":"LabeledBox_label__tsqdv"};